import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { trackExternalLink } from '../utils/analytics';

const FooterContainer = styled.footer`
  padding: 28px 56px;
  background: ${({ theme }) => theme.colors.bg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.10)`};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    padding: 24px 20px;
  }
`;

const Copyright = styled.p`
  font-family: 'DM Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.04em;
  color: ${({ theme }) => `rgba(${theme.colors.textRgb},0.45)`};
  margin: 0;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 8px;
`;

const SocialIcon = styled(motion.a)`
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: 14px;
  padding: 8px;
  border-radius: 6px;
  background: ${({ theme }) => `rgba(${theme.colors.textRgb},0.05)`};
  border: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.10)`};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 120ms ease, border-color 120ms ease, background 120ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    border-color: ${({ theme }) => `rgba(${theme.colors.textRgb},0.25)`};
    background: ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};
  }
`;

const Footer = () => (
  <FooterContainer>
    <Copyright>
      © {new Date().getFullYear()} C&amp;D Software — All rights reserved
    </Copyright>
    <SocialLinks>
      <SocialIcon
        href="https://www.linkedin.com/company/c-d-software/?viewAsMember=true"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackExternalLink('LinkedIn', 'https://www.linkedin.com/company/c-d-software/?viewAsMember=true')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaLinkedinIn />
      </SocialIcon>
      <SocialIcon
        href="https://x.com/cnd_software"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackExternalLink('Twitter/X', 'https://x.com/cnd_software')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaXTwitter />
      </SocialIcon>
    </SocialLinks>
  </FooterContainer>
);

export default Footer;
